import { ReactNode } from "react";

export const WebsiteDoubleSection = ({
  leftClassName = "",
  rightClassName = "",
  className = "",
  leftChild,
  rightChild,
}: {
  leftClassName?: string;
  rightClassName?: string;
  className?: string;
  leftChild: ReactNode;
  rightChild: ReactNode;
}) => {
  return (
    <div
      className={`flex flex-col lg:grid lg:grid-cols-2 items-center ${className}`}
    >
      <div className={`flex h-full w-full justify-end ${leftClassName}`}>
        <div
          className={`
            w-full h-full
            lg:max-w-max-1024-half
            width-lim:max-w-website-max-half width-lim-xl:max-w-website-max-xl-half
            !relative
            `}
        >
          {leftChild}
        </div>
      </div>

      <div className={`flex h-full w-full justify-start ${rightClassName}`}>
        <div
          className={`
            w-full h-full
            lg:max-w-max-1024-half
            width-lim:max-w-website-max-half width-lim-xl:max-w-website-max-xl-half
            `}
        >
          {rightChild}
        </div>
      </div>
    </div>
  );
};
